import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-pdf': {
    backgroundColor: COLORS.WHITE,
    color: COLORS.NEUTRAL800,
    padding: theme.space[5],

    '& .brief-pdf__title-block': {
      borderBottom: `2px solid ${COLORS.NEUTRAL200}`,
      marginBottom: theme.space[5],
      paddingBottom: theme.space[3],
    },
    '& .brief-pdf__subtitle': {
      color: COLORS.NEUTRAL600,
    },
    '& .brief-pdf__section': {
      marginBottom: theme.space[6],
    },
    '& .brief-pdf__section-title': {
      borderBottom: `1px solid ${COLORS.NEUTRAL200}`,
      marginBottom: theme.space[4],
      paddingBottom: theme.space[2],
    },
    '& .brief-pdf__section-icon': {
      color: COLORS.NEUTRAL500,
      marginRight: theme.space[2],
    },
    // Field labels sit below the section and module titles in the document hierarchy:
    // 30px document title > 24px section > 20px module > 18px field label.
    '& .brief-pdf__heading p': {
      fontSize: theme.fontSizes[3],
      marginBottom: theme.space[3],
    },
    '& .brief-pdf__module': {
      marginBottom: theme.space[5],
    },
    '& .brief-pdf__module-title': {
      borderBottom: `1px solid ${COLORS.NEUTRAL200}`,
      fontSize: theme.fontSizes[4],
      fontWeight: theme.fontWeights.heading,
      marginBottom: theme.space[3],
      paddingBottom: theme.space[2],
    },
  },
});
